import React from "react";

import "img/icons.svg";
import "jquery-modal";

import { getQueryParam } from "lib/util";
import wsStorage, { WS_STORAGE_KEY } from "lib/wsStorage";
import initJQuery from "lib/vendor/jquery";

import ModalContainer from "common/Modals";
import ToastContainer from "common/Toast";
import PortalAnnouncements from "portal/Announcements";
import AuthPassword from "apps/password";
import ErrorContainer from "apps/components/ErrorContainer";

initJQuery();

class AppContainer extends ErrorContainer {
    static authShown = false;

    componentDidMount() {
        if (
            (window.updatePassword || window.resetPassword) &&
            window.authUser &&
            (window.location.pathname.indexOf("portal") > -1 || window.location.pathname === "/")
        ) {
            const reset = !!getQueryParam("reset") || window.resetPassword;

            // Don't keep popping this up if they close it without setting a pw
            if (
                AppContainer.authShown ||
                (reset && wsStorage.getItem(WS_STORAGE_KEY.STOP_RESET_PASSWORD))
            ) {
                return;
            }

            // If we have multiple React mount points, this prevents auth from popping
            // up more than once.
            AppContainer.authShown = true;
            new AuthPassword({ reset }).render();
        }
    }

    renderContainer() {
        return (
            <div className="app-container">
                {this.props.children}
                <ModalContainer />
                <ToastContainer />
                <PortalAnnouncements />
            </div>
        );
    }
}

export default AppContainer;
